import { useEffect } from 'react'

import { useGetEtaToBookingByTrackingHashQuery } from 'generated/graphql'

interface UseBookingEtaOptions {
  trackingHash: string
  pollInterval?: number
  skip?: boolean
}

export const useBookingEta = ({
  trackingHash,
  pollInterval = 30000,
  skip = false,
}: UseBookingEtaOptions) => {
  const { data, loading, startPolling, stopPolling } = useGetEtaToBookingByTrackingHashQuery({
    fetchPolicy: 'cache-and-network',
    variables: { hash: trackingHash },
    skip: !trackingHash || skip,
  })

  useEffect(() => {
    if (!skip && trackingHash) {
      startPolling(pollInterval)
    }

    return () => {
      stopPolling()
    }
  }, [skip, trackingHash, pollInterval, startPolling, stopPolling])

  return {
    nextAddressEta: data?.etaToBookingByTrackingHash?.nextAddressETA ?? null,
    etaWindowMinutes: data?.etaToBookingByTrackingHash?.etaWindowMinutes ?? null,
    etaLoading: loading,
    startPolling,
    stopPolling,
  }
}
